import { FC } from 'react';

// Third-party
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';

// Components
import { BaseTooltip } from '@mgm/common/components/base';
import { CurrencyList } from './CurrencyList';

// Types
import { TScheduleFooter } from '../type';

// Assets
import { ReactComponent as CoinsIcon } from '../../Shared/static/ic_coins.svg';
import { useScheduleTotals } from '../../Shared/hooks';

const ScheduleFooter: FC<TScheduleFooter> = ({ selectedDate, isDayHeader = false }) => {
  const { totalData } = useScheduleTotals(selectedDate);

  return (
    <Box
      {...(isDayHeader && {
        display: 'flex',
        justifyContent: 'space-between',
      })}
      paddingY={1}
    >
      <Typography
        {...(isDayHeader && {
          color: 'primary',
        })}
        component="div"
        variant="caption"
      >
        {totalData.totalHours}
      </Typography>
      <Box justifyContent="center" alignItems="center" display="flex">
        <Typography
          {...(isDayHeader && {
            color: 'primary',
          })}
          marginRight={0.75}
          component="div"
          variant="caption"
        >
          {totalData.totalAmount?.toLocaleString()}
        </Typography>
        {
            totalData.isDisplayTooltip
            && (
            <BaseTooltip tooltipText={(
              <CurrencyList currencies={totalData.currencies} />
            )}
            >
              <SvgIcon fontSize="small" component={CoinsIcon} inheritViewBox />
            </BaseTooltip>
            )
        }
      </Box>
      {/* <Typography component="div" variant="caption">1 employee</Typography> */}
    </Box>
  );
};

export {
  ScheduleFooter,
};
